
import $ from 'jquery';

const states = [
	'success',
	'error',
	'warning',
];

const setInputState = ( element, state ) => {
	const $element = $( element );
	const $inputRow = $element.closest( '.input_row' );

	const $wrapper = $element.closest( '.input_row .input_wrapper' );

	$inputRow.removeClass( 'row_has_message' ).removeAttr( 'data-notification' );
	if ( $element.hasClass( 'showvalidatesuccess' ) ) {
		$inputRow.attr( 'data-notification', state );
	}

	// Skip if custom handling enabled.
	if ( $wrapper.hasClass( 'input_wrapper--custom_stateindicator' ) ) {
		return $wrapper;
	}

	$wrapper.removeAttr( 'data-state' );
	if ( $wrapper.hasClass( 'input_wrapper--has_stateindicator' ) ) {
		$wrapper.attr( 'data-state', state ).removeAttr( 'data-notification' );
	}
};

const setMessage = ( element, message = false, state = 'error' ) => {

	// Get Input Row.
	const $element = $( element );
	const $inputRow = $element.closest( '.input_row' );

	// Elements we manipulate.
	const $message = $inputRow.find( '.input_row_message' ).first();

	// Set Class for Message depending on State.
	$message.removeClass( states )
	if ( states.includes( state ) ) {
		$message.addClass( state );
	} else {
		$message.addClass( 'error' );
	}

	if ( message ) {
		$message.html( message );
	}

	// Display the Message.
	$inputRow.addClass( 'row_has_message' ).removeAttr( 'data-notification' );
};

const showError = ( element, message = false, state = 'error' ) => {
	setInputState( element, state );
	setMessage( element, message, state );
};

const hideError = ( element, state = 'success' ) => {
	setInputState( element, state );
};

class CustomError {
	constructor( fieldEl, message, type = 'error' ) {
		this.fieldEl = fieldEl;
		this.message = message;
		this.type = type;
	}

	show() {
		return showError( this.fieldEl, this.message, this.type );
	}
}

export { showError, hideError, setInputState, setMessage, CustomError };
